export const DEFAULT_DATE = 'YYYY-MM-DD HH:mm:ss';
export const DEFAULT_DAY = 'YYYY-MM-DD';
